import { useQuery } from "react-query";
import { apiCall } from "../../utils";

// https://github.com/tannerlinsley/react-query/blob/master/examples/custom-hooks/src/hooks/usePost.js

const getMetadataDetails = async id => {
  const { data } = await apiCall.get(`/metadata/download/${id}`);
  return data;
};

export const useCallMetadataById = id => {
  return useQuery(["metadata", id], () => getMetadataDetails(id), {
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export default useCallMetadataById;
